import React from "react";
import "./BookingForm.css";
import {
  FaMapMarkerAlt,
  FaBed,
  FaBath,
  FaCar,
  FaRulerCombined,
  FaUser,
  FaClock
} from "react-icons/fa";
import Navbar from "../Common Component/Navber";
import RentalFooter from "../Home/Footer";

const RentalBookingForm = () => {
  return (
    <>
    <Navbar/>
    <div className="rental-booking-wrapper">

      {/* LEFT FORM */}

      <div className="rental-booking-form-box">

        <h2 className="rental-booking-title">Personal information</h2>

        <div className="rental-booking-grid">

          <div className="rental-booking-field">
            <label>Full name *</label>
            <input type="text" placeholder="Exp. John Carter" />
          </div>

          <div className="rental-booking-field">
            <label>Email *</label>
            <input type="email" placeholder="Enter your email" />
          </div>

          <div className="rental-booking-field">
            <label>Phone number *</label>
            <input type="text" placeholder="(123) 000-0000" />
          </div>

          <div className="rental-booking-field">
            <label>Date *</label>
            <input type="date" />
          </div>

          <div className="rental-booking-field">
            <label>Time *</label>
            <input type="time" />
          </div>

          <div className="rental-booking-field">
            <label>Date *</label>
            <input type="date" />
          </div>

        </div>

        <div className="rental-booking-field rental-booking-message">
          <label>Any Message *</label>
          <textarea placeholder="Any Message from Your end"></textarea>
        </div>

        <button className="rental-booking-btn">Book Now</button>

      </div>


      {/* RIGHT PROPERTY CARD */}

      <div className="rental-booking-property-card">

        <div className="rental-booking-image-box">

          <span className="rental-booking-badge">For Rent</span>

          <img
            src="https://images.unsplash.com/photo-1600585154340-be6161a56a0c"
            alt="property"
          />

        </div>

        <div className="rental-booking-property-info">

          <h3 className="rental-booking-property-title">
            1963 S Crescent Heights Blvd
          </h3>

          <p className="rental-booking-location">
            <FaMapMarkerAlt /> Hills, CA 90210
          </p>

          <div className="rental-booking-features">

            <span>
              <FaRulerCombined /> 2400 Square Feet
            </span>

            <span>
              <FaCar /> 2 Garages
            </span>

            <span>
              <FaBed /> 20 Bedrooms
            </span>

            <span>
              <FaBath /> 8 Bathrooms
            </span>

          </div>

          <div className="rental-booking-agent">

            <span>
              <FaUser /> Michel Smith
            </span>

            <span>
              <FaClock /> 1 days ago
            </span>

          </div>

        </div>

        <div className="rental-booking-price">₹3,104.00</div>

      </div>

    </div>
    <RentalFooter/>
    </>
  );
};

export default RentalBookingForm;